import React from 'react';

import Helmet from 'react-helmet';

export default class NotFoundCanonical extends React.Component<{}> {
    public render() {
        return (
            <Helmet>
                   <link rel="canonical" href={`${window.location.protocol}//${window.location.host}/not-found`} />
            </Helmet>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/application/NotFoundCanonical.tsx